/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { useCallback } from 'react';
import type { Properties, User } from '@hackler/react-sdk';
import { createInstance } from '@hackler/react-sdk';
import type { HackleReactSDKClient } from '@hackler/react-sdk/lib/client';

import { ENV } from '~/utils/env';
import { isClient } from '~/utils/ssr';

/**
 * https://docs-kr.hackle.io/docs/
 * 나중에 다시 해클테스트를 할 수 있어서 해당 파일은 지우지 않음.
 * */

// https://docs-kr.hackle.io/docs/react-sdk-init
const config = {
  debug: ENV !== 'prod',
};

const SDK_KEY =
  ENV === 'prod'
    ? 'i4wk28HZWowii0Jh2oqqV9rTO9uUdvda'
    : 'uhYz982Q6RIOY7ZoUSjIZmcA6UkUV3hB';
export const hackleClient = createInstance(SDK_KEY, config);

declare global {
  interface Window {
    hackleClient?: HackleReactSDKClient;
  }
}

// GTM 연동 시 추가 script
if (isClient()) {
  window.hackleClient = hackleClient;
}

export const useHackleEvent = (eventName = 'clicked_product_thumbnail') => {
  const hackleEvent = useCallback(
    (properties: Properties = {}) => {
      hackleClient.track({
        key: eventName,
        properties,
      });
    },
    [eventName],
  );

  return hackleEvent;
};

export function setHackleUser(user: Partial<User>) {
  const prevUser = hackleClient.getUser();

  hackleClient.setUser({
    ...prevUser,
    ...user,
  });
}

export enum HACKLE_EXPERIMENT_KEY {
  SIMILAR_PRODUCTS = 47,
  PLUSMEMBERSHIP_NUDGE = 83,
  CATEGORY_PRODUCTS = 98,
  ML_RECOMMEND_PRODUCTS = 146,
  MEMBERSHIP_TRIAL_PRICE = 190,
}
